import React from 'react';
import { host_url } from "../../configiration/config";
import brandStyle from '../../pages/Home/Home.module.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../pages/Home/slickStyling.css';
import Slider from "react-slick";
import noImage from '../../assets/images/noImage.png';
import { filterLanguage } from './../../utilities/filterFunction';

export default function BrandsSlider({brandsHeader,brands}) {
    // slider settings
    var brandsSettings = {
        focusOnSelect: true,
        arrows: true,
        infinite: true,
        autoplay:true,
        speed: 600,
        slidesToShow: brands.length >= 5 ? 5 : brands.length,
        slidesToScroll:1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow:brands.length >= 4 ? 4 : brands.length,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: brands.length >= 3 ? 3 : brands.length,
                    slidesToScroll:1,
                    infinite: true,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            }
        ]
    };

    return (
        <div>
            {brands && brands.length > 0 &&
                <div className={`mb-5`}>
                   {brandsHeader && brandsHeader.locales && 
                    <div className={`${brandStyle.brandsContainer} `}>
                        <h2 className={brandStyle.sectionTitle}>{filterLanguage(brandsHeader.locales)[0].title}</h2>
                        <p className={brandStyle.sectionSubTitle}>{filterLanguage(brandsHeader.locales)[0].description}</p>
                    </div>
                    }
                    <Slider {...brandsSettings} className={`${brandStyle.brands} brandSlick`}>
                        {brands && brands.length > 0 ? brands.map((brand) => {
                            return (
                                <div key={brand.slug} className={`${brandStyle.brandName}`}>
                                    <img src={`${host_url}/${brand.image}`} className="w-100" alt={brand.name}   onError={(e)=>{e.target.src=noImage}}/>
                                </div>
                            )
                        }) :
                            <div></div>
                        }
                    </Slider>
                </div>
            }
        </div>
    )
}
